import React from 'react';

import { Component } from './component';
import {
  maxLength,
  name as nameValid,
  numberPositiveMin,
  number,
  required,
} from '../../lib/validation/service';
import { FormikValues, useFormik } from 'formik';
import { validation } from '../../lib/validation';
import { useMutation, useQueryClient } from 'react-query';
import { updateProject } from './action';
import { PROJECT_LIST_MODULE_NAME } from '../project-list';
import {
  ACTION_ERROR_INTER,
  FORM_VALUE_ENUM,
  FORM_VALUE_INTER,
  FORM_VALUE_TYPE,
} from '../project-item-create/constant';
import { convert } from '../project-item-create/convert';
import { SELECT_OPTION_ITEM_DATA } from '../../common/select';
import { USER_DATA } from '../../data/user/constant';

export const Container: React.FC<{
  id: string;
  name: string;
  budget: number;
  restBudget: number;
  uniqueNumber: number;
  responsible?: USER_DATA;
  close: Function;
}> = ({ id, name, close, budget, restBudget, responsible, uniqueNumber }) => {
  const query = useQueryClient();

  const onSuccess = (d: any, values: any) => {
    query.invalidateQueries(PROJECT_LIST_MODULE_NAME);
    formik.resetForm();
    close();
  };

  const action = useMutation(
    (values: FORM_VALUE_INTER) => updateProject(id, values),
    { onSuccess },
  );

  const config = {
    [FORM_VALUE_ENUM.NAME]: [required, nameValid, maxLength(80)],
    [FORM_VALUE_ENUM.BUDGET]: [required, number, numberPositiveMin(0)],
    [FORM_VALUE_ENUM.REST_BUDGET]: [required, number, numberPositiveMin(0)],
    [FORM_VALUE_ENUM.UNIQUE_NUMBER]: [required, number, numberPositiveMin(1)],
  };

  const validate = (values: FormikValues) => validation(values, config);

  const initialValues = {
    [FORM_VALUE_ENUM.NAME]: name,
    [FORM_VALUE_ENUM.BUDGET]: budget,
    [FORM_VALUE_ENUM.REST_BUDGET]: restBudget,
    [FORM_VALUE_ENUM.UNIQUE_NUMBER]: uniqueNumber,
    [FORM_VALUE_ENUM.RESPONSIBLE]: responsible?.id,
  };

  const formik: FormikValues = useFormik({
    initialValues,
    validate,
    enableReinitialize: true,
    onSubmit: (values: FORM_VALUE_INTER) => {
      return action.mutate(convert(values));
    },
  });

  const isFieldError = (name: FORM_VALUE_TYPE): boolean => {
    return formik.errors[name] && formik.touched[name] ? true : false;
  };

  const getFieldError = (name: FORM_VALUE_TYPE): string | undefined =>
    isFieldError(name) ? formik.errors[name] : undefined;

  const isSubmitDisabled = () => {
    if (!formik.isValid) {
      console.log('isValid');
      return true;
    }
    if (!formik.dirty) {
      console.log('dirty');

      return true;
    }

    if (action.isLoading) {
      console.log('isLoading');

      return true;
    }

    if (action.isSuccess) {
      console.log('isSuccess');

      return true;
    }
  };

  const isLoading = () => {
    if (action.isLoading) {
      return true;
    }
  };

  const isSuccess = () => {
    if (action.isSuccess) {
      return true;
    }
  };

  const isError = () => {
    if (action.isError && !action.isLoading && getErrorMessage()) {
      return true;
    }
  };

  const getErrorMessage = () => {
    const error: ACTION_ERROR_INTER = action.error as ACTION_ERROR_INTER;
    if (error) {
      return error.message;
    }
  };

  const getFieldValue = (name: FORM_VALUE_TYPE) => formik.values[name];

  const setFieldValue = (name: FORM_VALUE_TYPE, e: SELECT_OPTION_ITEM_DATA) => {
    formik.setFieldValue(name, e.value);
  };

  return (
    <Component
      isFieldError={isFieldError}
      getFieldError={getFieldError}
      isSubmitDisabled={isSubmitDisabled}
      getFieldValue={getFieldValue}
      formik={formik}
      isError={isError()}
      isLoading={isLoading()}
      isSuccess={isSuccess()}
      errorMessage={getErrorMessage()}
      close={close}
      setFieldValue={setFieldValue}
    />
  );
};
